import React, { useState } from "react";
import UserAvatar from "../Avatar/UserAvatar";

const ChatInfo = ({ isOpen, onClose, chat, onLeave, title = "Channel Info" }) => {
  const [loading, setLoading] = useState(false);
  
  if (!isOpen) return null;

  const handleLeave = async () => {
    setLoading(true);
    try {
      await onLeave();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex justify-end">
      <div className="bg-white w-full max-w-sm h-full flex flex-col shadow-xl">
        <div className="flex items-center gap-4 px-4 py-3 border-b border-gray-200">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 p-2 rounded-full hover:bg-gray-100">
            ←
          </button>
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        </div>
        <div className="p-6 flex flex-col flex-grow overflow-hidden">
          <div className="text-center mb-6">
            <h2 className="text-xl font-semibold text-gray-900">{chat?.name || "Unnamed Group"}</h2>
            <p className="text-sm text-gray-500">
              @{(chat?.groupType || "Learning").charAt(0).toUpperCase() + (chat?.groupType || "Learning").slice(1)}
            </p>
          </div>
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-gray-700 mb-2">INFO</h3>
            <p className="text-sm text-gray-600">{chat?.description || "No description available."}</p>
          </div>
          <div className="flex-grow overflow-y-auto mb-6">
            <h3 className="text-sm font-semibold text-gray-700 mb-2">{chat?.participants?.length ?? 0} PARTICIPANTS</h3>
            <div className="space-y-2">
              {chat?.participants?.map((p, i) => {
                const name = `${p.firstName || ""} ${p.lastName || ""}`.trim() || p.email || "Unknown User";
                return (
                  <div key={p._id || i} className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50">
                    <UserAvatar 
                      src={p.profilePhoto} 
                      alt={name} 
                      className="w-8 h-8" 
                      fallbackClassName="w-8 h-8"
                    />
                    <p className="text-sm font-medium text-gray-900">{name}</p>
                  </div>
                );
              })}
            </div>
          </div>
          {onLeave && (
            <button
              onClick={handleLeave}
              disabled={loading}
              className="w-full py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50"
            >
              {loading ? "Leaving..." : "Leave Group"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatInfo;
